import React from 'react'

import {
  Card,
  Grid,
  Typography,
  Box,
  Button,
  Collapse,
  Tooltip,
  Fade,
  IconButton,
  ToggleButtonGroup,
  ToggleButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  FormControlLabel,
  Switch,
} from '@mui/material'

import { useContext, useState, useEffect } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import { useFormDebounce } from 'hooks/useFormDebounce'

import { selectData } from 'layouts/onboarding'

import ValuePoint from 'admin/components/ValuePoint'
import { BalanceSheetRow } from 'layouts/authenticated/pages/dashboard/components/BalanceSheet/BalanceSheetRow'
import { AddCircleOutline, ExpandMore, MoreVert } from '@mui/icons-material'
import UserGoals from 'admin/components/UserGoals'
import FormField from 'components/FormField'
import { MenuItem } from '@aws-amplify/ui-react'
import TaskRecommendations from 'layouts/authenticated/pages/dashboard/components/TaskRecommendations'

function ToDoList({ collapseSections, toggleCollapse, userTasks, assets }) {
  return (
    <>
      <Grid item xs={12} md={4} xl={3}>
        <Card
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12}>
              <Typography variant="valueTitle">VALUE POINTS</Typography>
              <Collapse
                in={collapseSections.todo}
                style={{ width: '100%' }}
              ></Collapse>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={12} md={8} xl={9}>
        <Card
          id="todolist"
          sx={{
            overflow: 'visible',
            textAlign: 'left',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: 2,
            p: 2,
            pb: 0,
          }}
        >
          <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
            <Grid
              item
              xs={12}
              onClick={() => toggleCollapse('todo')}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h4" sx={{ flexGrow: 1 }}>
                To-Do List
              </Typography>
              <ExpandMore
                sx={{
                  height: '1.5em',
                  width: '1.5em',
                  transform: collapseSections.todo
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
            </Grid>
          </Grid>
          <Collapse in={collapseSections.todo} style={{ width: '100%' }}>
            <Grid container columnSpacing={3} rowSpacing={2} pb={2}>
              <Grid item xs={12} xxl={8}>
                <TaskRecommendations
                  userTasks={userTasks}
                  userAssets={assets}
                />
                <Button
                  rel="noreferrer"
                  // onClick={handleAddAccount}
                  startIcon={<AddCircleOutline />}
                  sx={{
                    padding: '8px 10px 7px',
                    backgroundColor: '#E4F0FF',
                    color: '#5D6D8E',
                    border: '1px solid #ADC5E3',
                    fontWeight: '500',
                    width: '100%',
                    boxShadow: 'none',
                    fontSize: '18px',
                    marginTop: '12px',
                    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                      transform: 'none',
                      backgroundColor: '#cdd8e5',
                      color: '#5D6D8E',
                      boxShadow: 'none',
                    },
                    '&>span': {
                      margin: '0 4px 0 0',
                    },
                    '&>span>svg': {
                      fontSize: '1.5rem !important',
                    },
                  }}
                >
                  Add Unlinked To-Do Item
                </Button>
              </Grid>
            </Grid>
          </Collapse>
        </Card>
      </Grid>
    </>
  )
}

export default ToDoList
